import { jsx } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import { formatValue } from "../utils/data.js";
import { formatDateTime } from "../utils/date.js";
const defaultFormat = {};
const Wrapper = styled(Box)(({
  theme
}) => ({
  justifyContent: "initial",
  padding: 0,
  display: "flex",
  "&.left": {
    padding: `0 0 0 ${theme.sizes.spacing["04"]}`,
    justifyContent: "flex-start"
  },
  "&.right": {
    padding: `0 ${theme.sizes.spacing["04"]} 0 0`,
    justifyContent: "flex-end"
  }
}));
const ValueSkeleton = styled(Skeleton)(({
  theme
}) => ({
  width: "6rem",
  height: "2rem",
  borderRadius: theme.sizes.radius.xs
}));
const Value = ({
  data,
  isLoading = false,
  float,
  format = {
    ...defaultFormat
  }
}) => {
  if (isLoading) {
    return /* @__PURE__ */ jsx(ValueSkeleton, { variant: "text" });
  }
  if (data === null) {
    return "--";
  }
  const {
    value,
    type,
    short = true,
    ...dataFormat
  } = data;
  const variant = "number-lg";
  const formatOptions = {
    type,
    short,
    precision: type !== "integer" ? 2 : 0,
    ...format,
    ...dataFormat
  };
  const tooltipFormatOptions = {
    ...formatOptions,
    short: false
  };
  let safeFormattedValue = "";
  let safeFormatTooltip = "";
  if (!value && value !== 0) {
    safeFormattedValue = "N/A";
    safeFormatTooltip = "N/A";
  } else if (typeof value === "number" && type === "duration") {
    safeFormattedValue = formatDateTime({
      value: Math.trunc(value),
      type,
      display: data.display_format
    });
    safeFormatTooltip = safeFormattedValue;
  } else if (typeof value === "number" && type !== "duration") {
    safeFormattedValue = formatValue(value, formatOptions);
    safeFormatTooltip = formatValue(value, tooltipFormatOptions);
  } else if (typeof value === "string") {
    safeFormattedValue = value;
    safeFormatTooltip = value;
  } else {
    console.warn("Unknown value type", {
      value,
      type
    });
    safeFormattedValue = "N/A";
    safeFormatTooltip = "N/A";
  }
  return /* @__PURE__ */ jsx(Wrapper, { float, children: /* @__PURE__ */ jsx(Tooltip, { title: safeFormatTooltip, children: /* @__PURE__ */ jsx(Typography, { variant, children: safeFormattedValue }) }) });
};
export {
  Value as default
};
